import { createContext } from "react";

export const SortableDataContext = createContext<{ id: string | undefined }>({
  id: undefined,
});
